module.exports = __webpack_public_path__ + "img/product-1.ce68d673.png";